/**
 * Login-Seite (ADR-003 v2, SSO): Anmeldung via SWA Built-in Auth / Entra.
 * Der Button leitet zu /.auth/login/aad (api.login()); nach dem Login kommt der
 * Nutzer zurueck. Wer bereits angemeldet ist, wird direkt aufs Cockpit geleitet.
 */
import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

export function LoginPage() {
  const { status, login } = useAuth();

  // Dev-Mock (Fixture): dort ist man immer angemeldet -> gar nicht anzeigen.
  useEffect(() => {
    // kein Auto-Redirect zur SSO — bewusst per Klick (kein ueberraschender Sprung).
  }, []);

  if (status === 'authenticated') {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-bg px-4">
      <div className="w-full max-w-sm space-y-4 rounded-lg border border-border bg-surface p-6 text-center shadow-sm">
        <h1 className="text-xl font-semibold text-text">LBU Quarterly Reporting</h1>
        <p className="text-sm text-text-muted">
          Anmeldung mit Ihrem DIH-Microsoft-Konto.
        </p>
        <button
          type="button"
          onClick={() => login()}
          disabled={status === 'loading'}
          className="w-full rounded bg-accent px-4 py-2 font-medium text-accent-fg hover:opacity-90 disabled:opacity-50"
        >
          Mit Microsoft-Konto anmelden
        </button>
        <p className="text-xs text-text-muted">
          Kein Zugriff? Bitte den Administrator um Freischaltung bitten.
        </p>
      </div>
    </div>
  );
}
